
import { mapGetters, mapState } from "vuex";

export default {
    name: "scavenger_hunt_bar",
    props: ["current360", "loaded360", "items", "week", "set", "isReleaseDlc"],
    data(){
        return {
            totalItems: 5,
            isOpen: false,
            selectedLang: "en",
            brokenItems: [],

            langText: {
                en: {
                    title: "Scavenger Hunt",
                    desc: "Find all 5 hidden items around this zone. Spot them, click them and earn MyWellness Points!",
                },
                cn: {
                    title: "趣味寻宝",
                    desc: "在当前场景中找出 5 个隐藏道具。发现并点击道具，即可赚取健康积分！",
                },
            },
        }
    },
    computed: {
        ...mapState({
            isStampCollectable: state => state.stamp.isStampCollectable,
            scavengerHuntFound: state => state.stamp.scavengerHuntFound,
        }),
        ...mapGetters({
            stampItems: "stamp/stampItems",
        }),
        zoneTitle(){
            return this.roomItems[this.loaded360];
        },
        huntItems(){
            const rawItems = this.items?.[this.loaded360] || [];
            return rawItems.filter(item => Boolean(item.isDLC) == true);
            // return rawItems.filter(item => Boolean(item.isDLC) == Boolean(this.isReleaseDlc));
        },
        setLabel(){
            return this.set? String(this.set).replace("ocbc360_", "") : "";
        },
        isShowScavengerHuntBar(){
            if(!this.isStampCollectable || !this.setLabel) return false;
            if(!this.current360 || this.current360 != this.loaded360) return false;
            return !["lobby", "lobby_m"].includes(this.loaded360);
        },
        foundItems(){
            if(!this.stampItems || !this.setLabel) return [];

            const foundItemsData = _.filter(this.stampItems, item => {
                return item.title.includes("Scavenger Hunt") && item.title.includes(`Set ${ this.setLabel }`) && item.room == this.roomItems[this.loaded360];
            });

            return _.compact(foundItemsData.map(item => {
                const matched = item.title.match(/Scavenger Hunt (1|2|3|4|5)/);
                return matched? parseInt(matched[1]) : null;
            }));
        },
    },
    methods: {
        isFound(item){
            return this.foundItems.includes(item);
        },
        itemImageSrc(item){
            return this.formattedAssetUrl(`/static/images/scavenger_hunt/${ this.loaded360 }/${ item }.png`);
        },
        itemName(item){
            return this.huntItems[item - 1]?.[`name_${ this.selectedLang }`] || "";
        },
        itemDesc(item){
            return this.huntItems[item - 1]?.[`desc_${ this.selectedLang }`] || "";
        },
        onClickToggleBtn(isOpen){
            this.isOpen = isOpen;
            this.onHandleTriggerAnalytics(`${ isOpen? "open" : "close" }@scavenger_hunt@${ this.loaded360 }`);
        },
    },
    watch: {
        "loaded360"(){
            this.isOpen = false;
            this.brokenItems = [];
        },
        "set"(){
            this.brokenItems = [];
            this.$store.commit("stamp/setScavengerHuntFound", false);
        },
    }
}
